import { ScrollView, Text, View } from "react-native";
import { useGetAllLocationsQuery } from "../../../services/api/locationsApi";
import LoadingSpinner from "ui/atoms/spinner/LoadingSpinner";
import { LocationDetailCard } from "../molecules/LocationDetailCard";
import { Button, ButtonIcon, ButtonText } from "ui/gluestack/button";
import { AddIcon } from "ui/gluestack/icon";
import { Portal } from "ui/modules/ThrelsPortal/Portal";
import { useRef } from "react";
import {
  CreateLocationModalRef,
  CreateLocationModal,
} from "../modals/CreateLocationModal";
import { PermissionCheck } from "app/features/permission/atoms/PermissionCheck";
import { PermissionsEnums } from "app/services/api/types/authorisation/enums/PermissionsEnums";

export function LocationsListTemplate() {
  const { data, isLoading } = useGetAllLocationsQuery();

  const createLocationModalRef = useRef<CreateLocationModalRef>(null);

  if (isLoading) {
    return (
      <View className="flex-1 justify-center items-center my-10">
        <LoadingSpinner />
      </View>
    );
  }

  return (
    <View className="flex-1 bg-white">
      <PermissionCheck permission={PermissionsEnums.CREATE_LOCATION}>
        <Portal hostName="headerButton" identifier="locationsList">
          <Button
            className="mb-3"
            action="primary"
            size="sm"
            onPress={() => createLocationModalRef.current?.show()}
          >
            <ButtonText>Create new location</ButtonText>
            <ButtonIcon as={AddIcon} className="w-4 h-4"></ButtonIcon>
          </Button>
        </Portal>
      </PermissionCheck>
      <ScrollView contentContainerClassName="px-dashboard">
        {data?.length ? (
          data?.map((location) => (
            <LocationDetailCard key={location.id} location={location} />
          ))
        ) : (
          <View className="flex-1 my-5">
            <Text className="text-typography-600">No locations available.</Text>
          </View>
        )}
      </ScrollView>

      <CreateLocationModal ref={createLocationModalRef} />
    </View>
  );
}
